(function () {
  const LIMIT_GRAMS = 30000;
  let lastValue = null;
  let isSyncing = false;
  let syncTimeout = null;
  let isOwnRequest = false; // Flag pour identifier nos propres requêtes

  async function syncCartWeightAttribute() {
    // Éviter les appels simultanés
    if (isSyncing) {
      return;
    }
    
    try {
      isSyncing = true;
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();

      const grams = Number(cart.total_weight || 0);
      const over = grams > LIMIT_GRAMS;
      const value = over ? 'true' : 'false';
      const weightKg = (grams / 1000).toFixed(1);

      // évite des appels inutiles si la valeur n'a pas changé
      if (lastValue === value && cart.attributes?.cart_weight_kg === weightKg) {
        isSyncing = false;
        return;
      }
      lastValue = value;

      // Marquer que c'est notre propre requête
      isOwnRequest = true;
      const updateRes = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            over_30kg: value,
            cart_weight_kg: weightKg
          }
        })
      });
      await updateRes.json();
      isOwnRequest = false;
    } catch (e) {
      isOwnRequest = false;
    } finally {
      isSyncing = false;
    }
  }

  // Fonction pour déclencher la synchronisation avec debounce
  function triggerSync(delay = 500) {
    if (syncTimeout) clearTimeout(syncTimeout);
    syncTimeout = setTimeout(() => {
      syncCartWeightAttribute();
    }, delay);
  }

  // 1) au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartWeightAttribute);
  } else {
    syncCartWeightAttribute();
  }

  // 2) après changements panier (AJAX themes) - uniquement ces événements
  document.addEventListener('cart:updated', () => triggerSync(500));
  document.addEventListener('cart:refresh', () => triggerSync(500));

  // 3) fallback : intercepter les fetch mais ignorer nos propres requêtes et /cart/update.js
  const _fetch = window.fetch;
  window.fetch = function () {
    const p = _fetch.apply(this, arguments);
    
    // Ignorer si c'est notre propre requête ou si c'est /cart/update.js
    if (isOwnRequest) {
      // Log silencieux pour éviter le spam
      return p;
    }
    
    try {
      const url = arguments[0]?.url || arguments[0];
      if (typeof url === 'string') {
        // Intercepter uniquement les requêtes qui modifient le panier (add, change, update)
        // mais pas /cart/update.js ni /cart.js (lecture seule)
        if (
          (url.includes('/cart/add.js') || 
           url.includes('/cart/change.js') || 
           url.includes('/cart/update.js')) &&
          !isOwnRequest
        ) {
          p.then(() => triggerSync(500));
        }
      }
    } catch (e) {
      // Erreur silencieuse lors de l'interception fetch
    }
    return p;
  };

  // 4) sécurité avant checkout (clic)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('a,button');
    if (!btn) return;
    if (
      btn.action?.includes('/checkout') ||
      btn.href?.includes('/checkout') ||
      btn.name === 'checkout' ||
      btn.dataset.checkout === 'true'
    ) {
      syncCartWeightAttribute();
    }
  });
})();
